import ReactMarkdown, { defaultUrlTransform } from "react-markdown";
import remarkGfm from "remark-gfm";

const PHONE = /(?<![\d[(])(\+?1[\s.-]?)?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-](\d{4})(?![\d\]])/g;
const linkPhones = (s) => s.replace(PHONE, (m, _c, a, b, c) => `[${m}](tel:+1${a}${b}${c})`);
const urlTransform = (url) => (/^tel:\+?\d+$/.test(url) ? url : defaultUrlTransform(url));
const components = { a: ({ href, children, ...p }) => href?.startsWith("tel:")
  ? <a href={href} className="phone-link" data-testid="phone-link">{children}</a>
  : <a href={href} target="_blank" rel="noreferrer" {...p}>{children}</a> };

export const Markdown = ({ children, testid }) => (
  <div className="md" data-testid={testid}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} urlTransform={urlTransform} components={components}>{linkPhones(children || "")}</ReactMarkdown>
  </div>
);
